// Libs
import invert from 'lodash/invert'
import sortBy from 'lodash/sortBy'

// Static assets
import {
  CommercialTopTypologies,
  NewConstructionsTopTypologies,
  ResidentialTopTypologies,
  TopTypologies,
} from './typologies'
import { Sections } from './sections'

// Routes //////////////////////////////////////////////////////////////////////

export const Listing = 'listing'
export const NoZone = 'listing-no-zone'
export const NoCity = 'listing-no-city'
export const Showcase = 'listing-showcase'
export const ListingRoutes = { Listing, NoZone, NoCity, Showcase }
export const ListingRoutesEnum = Object.values(ListingRoutes)
export const ListingRoutesWithoutShowcaseEnum = Object.values({
  Listing,
  NoZone,
  NoCity,
})
export const ListingRoutesRegex = /^\/(?<section>venditaimmobili|nuovecostruzioni|immobilicommerciali|immobilidipregio|proprieta-unicredit)(?<province>\/[a-z]{2})?(?<city>\/[a-z-]+)?(?<zone>\/[a-z-]+)?(?<typology>\/appartamento|attico|villa|villa-a-schiera|villa-unifamiliare|villa-bifamiliare|villa-trifamiliare|villa-quadrifamiliare|villetta|mansarda|loft|immobile-di-prestigio|stabile-palazzo|casa-indipendente|porzione-di-casa|rustico|casa-colonica|casale|terratetto-terracielo|ufficio|studio|locale-commerciale|capannone|laboratorio|magazzino|deposito|attivita-commerciale|negozio|bar-tabacchi-ricevitoria|generi-monopolio-giochi|ristorante|bar-tavola-calda-fredda|enoteca-wine-bar|pasticceria-gelateria|discoteca-disco-pub-locale-notturno|alimentari-gastronomia|frutta-e-verdura|macelleria-salumeria|panificio-pastificio|pescheria|supermercato-minimarket|carrozzeria-officina-elettrauto|autolavaggio|concessionario|ricambi-e-accessori|garage-autosilos-parcheggio|gommista|audio-video|computer-informatica|sala-giochi|musica-e-strumenti|videoteca-videogames|telefonia-cellulari-elettrodomestici|internet-point-phone-center|hotel|agenzia-viaggi-e-turismo|bed-and-breakfast|articoli-sportivi|abbigliamento-intimo|calzature-pelletteria-valigeria|gioielleria-bijoutteria-orologeria|merceria|centro-estetico-solarium-benessere|profumeria-e-cosmetica|parrucchieri-uomo-donna|palestra-e-impianti-sportivi|articoli-caccia-e-pesca|colorificio-ferramenta-elettricita|edicola-edicola-con-chiosco|farmacia-erboristeria|piante-e-fiori|foto-ottica|giocattoli-gadget|impresa-pulizia|lavanderia-tintoria|cartoleria-libreria|materiali-e-prodotti-edilizi|mobili-arredanento|articoli-da-regalo-casalinghi|idraulica-elettricita|riparazioni-fai-da-te|tempo-libero|agenzia-intermediazioni-immobiliari|agenzia-intermediazioni-creditizie|trullo|dammuso|nuraghe|maso|baglio|rifugio|sasso|baita|agriturismo|residence|multiproprieta|bungalow|terreno-agricolo|terreno-residenziale|terreno-commerciale|box|posto-auto|posto-moto|cascina|show-room|pensione|ostello|relais|hotel-di-lusso|campeggio|stabilimento-balneare|terreno-industriale|terreno-artigianale-terziario|terreno-turistico|stanza-camera|posto-barca|posto-camper-roulotte|auto-silos|castello|dimora-storica|torre|palazzo-storico|villa-storica|convento-monastero|centralina|consorzio-agrario|filiale-bancaria|scuderia|struttura-ricettiva|struttura-commerciale|stabile|palazzo|terratetto|terracielo|bar|tabacchi|ricevitoria|enoteca|wine-bar|pasticceria|gelateri|discoteca|disco-pub|locale-notturno|alimentari|gastronomia|macelleria|salumeria|panificio|pastificio|supermercato|minimarket|carrozzeria|officina|elettrauto|ricambi|accessori|garage|autosilos|parcheggio|computer|informatica|musica|strumenti|videoteca|videogames|telefonia|cellulari|elettrodomestici|internet-point|phone-center|agenzia-viaggi|abbigliamento|intimo|calzature|pelletteria|valigeria|gioielleria|bijoutteria|orologeria|centro-estetico|solarium|benessere|profumeria|parrucchiere|palestra|impianto-sportivo|caccia-e-pesca|colorificio|ferramenta|elettricita|edicola|farmacia|giocattoli|lavanderia|tintoria|cartoleria|Libreria|materiali-edilizi|prodotti-edilizi|mobili|arredamento|articoli-regalo|casalinghi|idraulica|riparazioni|fai-da-te|agenzia-immobiliare)?(?<subtypology>\/monolocale|bilocale|trilocale|oltre3locali)?$/

// Sorting /////////////////////////////////////////////////////////////////////

export const Ranking = 'ranking'
export const Price = 'price'
export const PriceDesc = '-price'
export const Date = 'date'
export const DateDesc = '-date'
export const Square = 'square'
export const SquareDesc = '-square'

export const Rilevanza = 'rilevanza'
export const Prezzo = 'prezzo'
export const PrezzoDesc = 'prezzoDesc'
export const Data = 'data'
export const DataDesc = 'dataDesc'
export const Superficie = 'superficie'
export const SuperficieDesc = 'superficieDesc'

export const ListingSortingValues = {
  Ranking,
  Price,
  PriceDesc,
  Date,
  DateDesc,
  Square,
  SquareDesc,
}
export const SortingValuesEnum = Object.values(ListingSortingValues)

export const ListingSortingMapFromUrl = {
  [Rilevanza]: Ranking,
  [Prezzo]: Price,
  [PrezzoDesc]: PriceDesc,
  [Data]: Date,
  [DataDesc]: DateDesc,
  [Superficie]: Square,
  [SuperficieDesc]: SquareDesc,
}
export const ListingSortingMapToUrl = invert(ListingSortingMapFromUrl)

export const ListingSortingItems = [
  {
    value: Ranking,
    label: 'Più rilevanti',
  },
  {
    value: Price,
    label: 'Meno costosi',
  },
  {
    value: PriceDesc,
    label: 'Più costosi',
  },
  {
    value: Date,
    label: 'Meno recenti',
  },
  {
    value: DateDesc,
    label: 'Più recenti',
  },
  {
    value: Square,
    label: 'Meno grandi',
  },
  {
    value: SquareDesc,
    label: 'Più grandi',
  },
]

// Queries /////////////////////////////////////////////////////////////////////

export const Ascensore = 'ascensore'
export const Bagni = 'bagni'
export const Balcone = 'balcone'
export const BoxAuto = 'boxAuto'
export const Criterio = 'criterio'
export const Giardino = 'giardino'
export const LocaliMassimo = 'localiMassimo'
export const LocaliMinimo = 'localiMinimo'
export const Mappa = 'mappa'
export const MetriQuadriMassimo = 'metriQuadriMassimo'
export const MetriQuadriMinimo = 'metriQuadriMinimo'
export const PrezzoMassimo = 'prezzoMassimo'
export const PrezzoMinimo = 'prezzoMinimo'
export const Terrazzo = 'terrazzo'
export const Zone = 'zone'

export const ListingQuery = {
  Ascensore,
  Bagni,
  Balcone,
  BoxAuto,
  Criterio,
  Giardino,
  LocaliMassimo,
  LocaliMinimo,
  Mappa,
  MetriQuadriMassimo,
  MetriQuadriMinimo,
  PrezzoMassimo,
  PrezzoMinimo,
  Terrazzo,
  Zone,
}

export const ListingQueryEnum = Object.values(ListingQuery)
export const ListingQueryMapFromUrl = {
  [Ascensore]: 'elevator',
  [Bagni]: 'bathrooms',
  [Balcone]: 'balcony',
  [BoxAuto]: 'box',
  [Criterio]: 'sort',
  [Giardino]: 'garden',
  [LocaliMassimo]: 'roomsTo',
  [LocaliMinimo]: 'roomsFrom',
  [Mappa]: 'map',
  [MetriQuadriMassimo]: 'surfaceTo',
  [MetriQuadriMinimo]: 'surfaceFrom',
  [PrezzoMassimo]: 'priceTo',
  [PrezzoMinimo]: 'priceFrom',
  [Terrazzo]: 'terrace',
  [Zone]: 'zones',
}
export const ListingQueryMapToUrl = invert(ListingQueryMapFromUrl)

// Pagination //////////////////////////////////////////////////////////////////

export const PerPage = 8

// Tabs ////////////////////////////////////////////////////////////////////////

export const Map = 'map'
export const List = 'list'
export const ListingTabs = { Map, List }

// Helpers /////////////////////////////////////////////////////////////////////

export function mapQuery(query) {
  const result = {}

  for (const it in query) {
    const key = ListingQueryMapFromUrl[it]
    result[key] = isNaN(query[it]) ? query[it] : Number(query[it])
  }

  if (result.zones) {
    result.zones = result.zones.split(',')
  }

  if (!result.sort) {
    return result
  }

  return { ...result, sort: ListingSortingMapFromUrl[result.sort] }
}

// Filters /////////////////////////////////////////////////////////////////////

export const Box = [
  { value: 0, name: 'Assente' },
  { value: 1, name: 'Singolo' },
  { value: 2, name: 'Doppio' },
  { value: 3, name: 'Triplo' },
]

export const Bathrooms = [
  { value: 1, name: 'Singolo' },
  { value: 2, name: 'Doppio' },
  { value: 3, name: 'Triplo' },
  { value: 4, name: 'Da tre in su' },
]

// Computed ////////////////////////////////////////////////////////////////////

export function computeTopTypologies(sectionSlug, typologies) {
  const typologiesEnumMap = {
    [Sections.VenditaImmobili]: ResidentialTopTypologies,
    [Sections.NuoveCostruzioni]: NewConstructionsTopTypologies,
    [Sections.ImmobiliCommerciali]: CommercialTopTypologies,
  }

  const typologiesEnum = typologiesEnumMap[sectionSlug] || TopTypologies

  const filteredTypologies = typologies.filter((it) =>
    typologiesEnum.includes(it.slug)
  )
  const computedTypologies = sortBy(filteredTypologies, 'slug')

  return computedTypologies
}

export function computedTopTypologies() {
  const { section } = this

  if (!section) {
    return
  }

  const { typologies } = this

  return computeTopTypologies(section.slug, typologies)
}

export function computedTypologies() {
  const { typologies, section } = this

  const topTypologies = []
  const otherTypologies = []

  const topTypologiesEnum =
    section.slug === Sections.ImmobiliCommerciali
      ? CommercialTopTypologies
      : ResidentialTopTypologies

  for (const it of typologies) {
    if (topTypologiesEnum.includes(it.slug)) {
      topTypologies.push(it)
      continue
    }

    otherTypologies.push(it)
  }

  const sortedTopTypologies = sortBy(topTypologies, 'slug')

  return [...sortedTopTypologies, ...otherTypologies]
}
